import { RootState } from 'redux/store'

export const applicationsSelectedRangeSelector = (state: RootState) =>
  state.applicationsReducer.applicationsSelectedRange

export const applicationsArchiveSelectedRangeSelector = (state: RootState) =>
  state.applicationsReducer.applicationsArchiveSelectedRange
